import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import WebpayConfirmation from './WebpayConfirmation';
import WebpayFail from './WebpayFail';
import WebpayRejected from './WebpayRejected';
import AESCrypt from '../../../helpers/crypto';
import Env from '../../../config/environment';
import urlDecode from '../../../helpers/urlDecode';
import NotFound from '../../../views/NotFound';
import { Spin } from 'antd';
import { SAVE_WEBPAY_DATA } from '../../../state/webpay/types';
import PropTypes from 'prop-types';
import { trackEvent } from '../../../helpers/analytics';

const env = Env();

const WebpayPaymentReceipt = ({ saveWebpayData }) => {
  const { body, iv } = useParams();
  const [view, setView] = useState(null);
  const [data, setData] = useState(null);
  const [loaderSpinning, setLoaderSpinning] = useState(true);

  const decodeUrl = () => {
    try {
      const json = AESCrypt.decrypt(
        env.key,
        Buffer.from(urlDecode(iv), 'base64'),
        urlDecode(body)
      );
      const parseData = JSON.parse(json);
      saveWebpayData(parseData);
      setData(parseData);
    } catch (error) {
      //404 - not found
      setView(3);
    }
  };

  useEffect(() => {
    decodeUrl();
  }, []);

  useEffect(() => {
    /*
    payment status:
      0 Confirmar transaccion
      1 Anulado por timeout
      2 Pago anulado por usuario
      3 Pago invalido
    */
    if (data) {
      if (data.paymentStatus === 0) {
        if (data.response_code === 0) {
          //success
          trackEvent('Payment', 'payment_completed', 'Pago exitoso', data.amount);
          setView(0);
        } else {
          //fail
          trackEvent('Payment', 'payment_failed', `Código error: ${data.response_code}`, data.amount);
          setView(1);
        }
      } else if (data.paymentStatus === 1 || data.paymentStatus === 3) {
        //fail
        trackEvent('Payment', 'payment_failed', `Status: ${data.paymentStatus}`, data.amount);
        setView(1);
      } else if (data.paymentStatus === 2) {
        //reject
        trackEvent('Payment', 'payment_rejected', 'Anulado por usuario', data.amount);
        setView(2);
      } else {
        //not found
        setView(3);
      }
    }
  }, [data]);

  useEffect(() => {
    setLoaderSpinning(false);
  }, [view]);

  return (
    <React.Fragment>
      {loaderSpinning ? (
        <Spin className='spin-centered' tip='Cargando...'></Spin>
      ) : (
        <React.Fragment>
          {view === 0 && <WebpayConfirmation />}
          {view === 1 && <WebpayFail />}
          {view === 2 && <WebpayRejected />}
          {view === 3 && <NotFound />}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

WebpayPaymentReceipt.propTypes = {
  persistContractId: PropTypes.string.isRequired,
  saveWebpayData: PropTypes.func.isRequired,
};

const data = (state) => ({
  persistContractId: state.contract.persistContractId,
});

const actions = (dispatch) => ({
  saveWebpayData: (param) =>
    dispatch({ type: SAVE_WEBPAY_DATA, payload: param }),
});

export default connect(data, actions)(WebpayPaymentReceipt);
